<template>
  <div>
    <div v-show='!submitted && !responded'>
      <div v-show="submitted" class="alert alert-success">You have submitted successfully</div>
      <div v-show="!submitted" class="alert alert-info" role="alert">
        {{mr.candidateName}} has signed up to serve as {{mr.ministryRole.name}} in {{mr.ministryRole.department}}
        <br><br>
        <p v-show="mr.ministryRole.criteria">
          <b>Please ensure the candidate fulfils the following criterias:</b>
          <br><br>
          <ul>
            <li v-for="c in json(mr.ministryRole.criteria)">{{c}}</li>
          </ul>
        </p>
      </div>
      <div v-show="!submitted" class='row'>
        <button class="btn btn-success offset-md-1 col-md-10 col-xs-12 my-2" :disabled="showRemarks" v-on:click="approve">Approve</button>
        
        <button class="btn btn-danger offset-md-1 col-md-10 col-xs-12 my-2" :disabled="showRemarks" v-on:click="onClickDecline">Decline</button>

        <button class='btn btn-info offset-md-1 col-md-10 col-xs-12 my-2' :disabled="showRemarks" v-on:click="onClickContactMe">I have concerns, contact me</button>
        
        
      </div>
      <br>
      <div class="row" v-show="showRemarks && !submitted">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <div>
            <div class="form-group">
              <textarea
                class="form-control"
                v-model="reason"
                placeholder="Enter reason(s) for the decline"
              ></textarea>
            
            </div>
            <button class="btn btn-default" v-on:click="undo">Back</button>
            <button class="btn btn-primary" v-on:click="submit">Submit</button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="submitted && !responded" class='col-md-4 offset-md-4 col-xs-12'>
      <br>
      <br>  
      <p v-show='approvalStatus == 2'>Your response is received. The Ministry Leader will contact you soon.</p>
      <p v-show='approvalStatus == 1'>Your response is received. The Ministry Leader will process the applicant soon.</p>
      <p v-show='approvalStatus == 0'>Please speak to the applicant personally to explain the reason for declining their application for this role within 7 days. After 3 days, an SMS will be sent to the applicant to inform them.</p>
    </div>
    <div v-show='responded' class='col-md-4 offset-md-4 col-xs-12'>
      <br><br>
    You have responded to this application<br>on {{respondedTimestamp | moment("DD MMM YY, HH:mma")}}. <br>Should you have any concerns, please write in to contribute@hopesingapore.org.sg
  </div>
  </div>
  
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      mr: {},
      showRemarks: false,
      reason: "",
      submitted: false,
      approvalStatus:-1,
      responded:false,
      respondedTimestamp:null
    };
  },
  methods: {
    undo:function(){
      this.showRemarks = false;
    },
    getMinistryRequest: async function() {
      var id = this.$route.query.id;

      var response = await http.get("/ministryrequest/id/" + id);
      if (response.status == 200) {
        this.mr = response.data;
        if(this.mr.approvalReceived){
          this.responded = true;
          this.respondedTimestamp = this.mr.approvalReceived;
        }
      }
    },
    onClickContactMe:async function(){
      this.approvalStatus = 2;
      this.submit();
    },
    onClickDecline: async function() {
      this.showRemarks = true;
      this.approvalStatus = 0;
    },
    submit: async function() {

      var response = await http.get(
        "/ministry/approval/" + this.mr.id + "?approve="+this.approvalStatus+"&reason=" + this.reason
      );
      if (response.status == 200) {
        this.submitted = true;
      }
    },
    approve: async function() {
      var response = await http.get(
        "/ministry/approval/" + this.mr.id + "?approve=1"
      );
      if (response.status == 200) {
        this.submitted = true;
      }
    },

    json: function(val){
        if(typeof val !== 'undefined'){
          return JSON.parse(val);
        }
    }
  },
  beforeMount: function() {
    this.getMinistryRequest();
  }
};
</script>

<style>
</style>
